export enum ValidationErrorCategory {
    BasicInformation = 'Basic Information',
    ItemVendor = "Item / Vendor",
    Attachments = "Attachments",
    Tagging = "Tagging"
};
export interface ValidationErrorMessage {
    message: string;
    category: ValidationErrorCategory;
}